import {ITemplateListDefinitions} from "@syginc/tellus-client";
import {LRUCache} from "lru-cache";

import {AdminApi} from "../../api/api";
import {TemplateListOutput} from "../../api/values/database-list-output";
import {shouldSkipTemplateListDefinitionsFetch} from "./template-fetch-policy";

// キャッシュキー
const templateListCacheKeyPrefix = "template-list";

// LRUキャッシュ（1分間有効）
const templateListCache = new LRUCache<string, Promise<ITemplateListDefinitions[]>>({
    ttl: 60 * 1000,
    max: 100, // テンプレート一覧は 1 件分の結果だけ使うので上限を設けて警告を防ぐ
});

async function getTemplateListDefinitionsFromApi(
    adminApi: AdminApi,
): Promise<ITemplateListDefinitions[]> {
    let mediaId = "";
    const segments = window.location.pathname.split("/");
    if (segments[1] === "admin" && segments.length >= 3) {
        // URLのパスからmediaIdを取得
        mediaId = segments[2];
    }

    // 全ページ取得
    let page = 1;
    let nextPageExists = true;
    const allTemplates: TemplateListOutput["templates"] = [];

    while (nextPageExists) {
        const result = await adminApi.getTemplates({page, mediaId, pageSize: 100});

        allTemplates.push(...result.templates!);
        nextPageExists = result.nextPageExists;
        page++;
    }

    // 結果を統合して返す
    return allTemplates.map((template) => ({
        id: template.id.toString(),
        title: template.title,
    }));
}

export async function getTemplateListDefinitions(
    adminApi: AdminApi,
): Promise<ITemplateListDefinitions[]> {
    // 削除済みテンプレート表示中はテンプレート一覧キャッシュの再取得を行わない
    if (shouldSkipTemplateListDefinitionsFetch()) {
        return [];
    }

    const cacheKey = `${templateListCacheKeyPrefix}`;
    const cacheEntry = templateListCache.get(cacheKey);

    if (cacheEntry) {
        console.log(`getTemplateList called, cache hit for ${cacheKey}`);
        return cacheEntry;
    }

    return cacheTemplateListDefinitions(adminApi);
}

export function cacheTemplateListDefinitions(
    adminApi: AdminApi,
): Promise<ITemplateListDefinitions[]> {
    // 削除済みテンプレート表示中はテンプレート一覧キャッシュの再取得を行わない
    if (shouldSkipTemplateListDefinitionsFetch()) {
        return Promise.resolve([]);
    }

    const result = getTemplateListDefinitionsFromApi(adminApi);
    const cacheKey = `${templateListCacheKeyPrefix}`;
    templateListCache.set(cacheKey, result);
    return result;
}
